import { Mutation } from 'vuex'
import { MediaLibraryState } from '../types'
import { MediaLibraryImage } from '@/types/mediaLibrary'

const deleteImageMediaLibrary: Mutation<MediaLibraryState> = (
  state,
  payload: MediaLibraryImage & { index_delete: number }
) => {
  const mediaLibrary = new Map(state.value)
  const mediaLibraryItem = mediaLibrary.get(payload.essence)

  if (mediaLibraryItem) {
    mediaLibraryItem.images.splice(payload.index_delete, 1)

    state.value = mediaLibrary
  }
}

export default deleteImageMediaLibrary
